import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 禁用菜单事件类
 */

export default class EventDisableMenu extends EventBase {
  constructor() {
    super()
  }

  /**
   * 事件ID
   */
  Code = EventID.DisableMenu

  /**
   * 获取描述信息
   */
}
